import Box from "@mui/material/Box";
import React from "react";
import { useStyles } from "./staticCardStyles";
import { IStaticCard } from "./IStaticCard";

const StaticCard = ({ message, backgroundImage, onClick }: IStaticCard) => {
    const { classes } = useStyles({ backgroundImage });

    return (
        <Box data-name="StaticCard" onClick={onClick} className={classes.card}>
            <div className="gradient" />
            <span className={classes.cardMessage}>
                {message.substring(0, 60)}
            </span>
        </Box>
    );
};

export default StaticCard;
